import { ConfigService } from './config.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HelpConfig {

  constructor(private configService: ConfigService) { }

  public get BASE_API(): string { return this.configService.getUrl('RINSPECTION_WEB', 'URL'); }
  
  public get HOMOLGATION_API(): string { return this.configService.getEndPoint('RINSPECTION_WEB', 'HOMOLOGATION'); }
  
  public get IDENTITY_API(): string { return this.configService.getEndPoint('RINSPECTION_WEB', 'IDENTITY'); }

  public get MONITORING_ENVIRONMENT(): string | null { return this.configService.getKey("MONITORING_ENVIRONMENT"); }
  
  public get LOKI_URL(): string | null { return this.configService.getUrlRaw("LOKI", "URL"); }
  
  public get OCR_API(): string { return this.configService.getUrl('OCR_API', 'URL'); }

  public get LIST_POLLING_INTERVAL_MS(): string | null { return this.configService.getKey("LIST_POLLING_INTERVAL_MS"); }

  public get LIST_POLLING_MIN_BACKOFF_MS(): string | null { return this.configService.getKey("LIST_POLLING_MIN_BACKOFF_MS"); }

  public get LIST_POLLING_MAX_BACKOFF_MS(): string | null { return this.configService.getKey("LIST_POLLING_MAX_BACKOFF_MS"); }
}
